import { Button, Col, Row, Span } from 'components'
import { useLoading, useMovement } from 'hooks'
import { DownloadXlsFornecedorServices } from 'services/Supplier/LogicalEffective'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'

const OrientacaoTemplateButtons = () => {
  const { selectedMovement, handleError } = useMovement()
  const { setLoading } = useLoading()

  const handleDownloadTemplate = async () => {
    try {
      setLoading('loading')
      const response = await DownloadXlsFornecedorServices().getXlsFornecedor()
      if (response.status !== 200)
        throw new Error('Não foi possivel baixar template.')

      downloadURI(response.data, 'template-fornecedor.xls')
      setLoading('idle')
    } catch (error: any) {
      handleError(error)
    }
  }

  const downloadURI = (uri, name) => {
    const link = document.createElement('a')
    link.download = name
    link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${uri}`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <Row
      alignItems="center"
      justifyContent="space-between"
      style={{ flexWrap: 'nowrap' }}
    >
      <Row alignItems="center" style={{ width: '50%' }}>
        <Col marginRight={SPACING.spacing20}>
          <Span
            text={selectedMovement?.cdContrato}
            color={COLORS.blueFonts}
            fontWeight={FONTS.bold}
            fontSize={TYPOGRAPHY.bodySize16}
          />
          <Span
            text={selectedMovement?.txObjetoContrato}
            marginTop={SPACING.spacing10}
            color={COLORS.black}
            fontWeight={FONTS.bold}
            fontSize={TYPOGRAPHY.bodySize16}
          />
        </Col>
        <Col>
          <Row alignItems="center">
            <Span
              text={`Ini.`}
              marginRight={SPACING.spacing5}
              color={COLORS.blueFonts}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
            <Span
              text={`${FORMAT.formatDDMMYYYY(
                selectedMovement?.dtVigenciaInicio
              )} - `}
              color={COLORS.black}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
            <Span
              text={`Fim`}
              marginLeft={SPACING.spacing5}
              marginRight={SPACING.spacing5}
              color={COLORS.blueFonts}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
            <Span
              text={`${FORMAT.formatDDMMYYYY(selectedMovement?.dtVigenciaFim)}`}
              color={COLORS.black}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
          </Row>

          <Span
            text={selectedMovement?.nmEmpresaFornecedor}
            marginTop={SPACING.spacing10}
            color={COLORS.black}
            fontWeight={FONTS.bold}
            fontSize={TYPOGRAPHY.bodySize16}
          />
        </Col>
      </Row>
      <Row>
        <Button text="Download Template" onClick={handleDownloadTemplate} />
      </Row>
    </Row>
  )
}

export default OrientacaoTemplateButtons
